import r, { OPTIONS as D } from "../managers/braze-instance.js";
import ro from "../util/browser-detector.js";
import mr from "./l10n-manager.js";
const Me = {
  i: !1,
  na: null,
  ra: () => {
    if ((Me.t(), !Me.na)) {
      let e = ro.language,
        t = !1;
      r.re(D.Wa) && ((e = r.re(D.Wa)), (t = !0)), (Me.na = new mr(e, t));
    }
    return Me.na;
  },
  t: () => {
    Me.i || (r.g(Me), (Me.i = !0));
  },
  destroy: () => {
    (Me.na = null), (Me.i = !1);
  },
};
export default Me;
